export const site = {
  brand: "51-每日大赛",
  slogan: "每日赛事资讯 · 今日黑榜 mdrs 排行",
  intro:
    "51-每日大赛是一个专业赛事资讯平台，聚合每日最新赛事资讯、比赛安排与今日黑榜 mdrs 排行，覆盖足球、篮球、赛车、电竞、拳击及综合项目，帮助体育赛事关注者、分析师与竞猜用户快速掌握赛事实时动态。",
  contact: {
    email: "info@51dailygames.example",
    business: "cooperation@51dailygames.example",
    phone: "400-051-5000",
    address: "上海市浦东新区赛事数据大厦 18 层",
    hours: "每日 08:00 - 24:00（赛事日延长服务）",
  },
  socials: [
    { name: "微信公众号", icon: "ri-wechat-line" },
    { name: "微博", icon: "ri-weibo-line" },
    { name: "哔哩哔哩", icon: "ri-bilibili-line" },
    { name: "抖音", icon: "ri-tiktok-line" },
  ],
  stats: [
    { label: "日均收录赛事", value: "320+" },
    { label: "覆盖赛事类别", value: "6 大类" },
    { label: "黑榜日更条目", value: "50 条" },
    { label: "数据更新频率", value: "5 分钟" },
  ],
  nav: [
    { label: "首页", path: "/" },
    { label: "赛事分类", path: "/category/football" },
    { label: "今日黑榜", path: "/blacklist" },
    { label: "关于我们", path: "/about" },
  ],
  footerLinks: [
    {
      title: "赛事导航",
      items: [
        { label: "足球资讯", path: "/category/football" },
        { label: "篮球资讯", path: "/category/basketball" },
        { label: "赛车资讯", path: "/category/racing" },
        { label: "电竞资讯", path: "/category/esports" },
      ],
    },
    {
      title: "数据服务",
      items: [
        { label: "今日黑榜排行", path: "/blacklist" },
        { label: "比赛安排", path: "/category/other" },
        { label: "关于我们", path: "/about" },
      ],
    },
  ],
};